import React from 'react';
import Messages from '../../components/Message';

function Contacts() {
    return (
        <>
            <Messages />
        </>
    )
}

export default Contacts;
